import script from "./PatientDetailsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientDetailsView.vue?vue&type=script&lang=ts&setup=true"

import "./PatientDetailsView.vue?vue&type=style&index=0&id=2ba48ab0&lang=scss"

const __exports__ = script;

export default __exports__